import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgViewLanguage({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M10.95 3.2c.966 0 1.75.784 1.75 1.75v9a1.75 1.75 0 01-1.75 1.75h-9A1.75 1.75 0 01.2 13.95v-9c0-.966.784-1.75 1.75-1.75zm0 1.5h-9a.25.25 0 00-.25.25v9c0 .138.112.25.25.25h9a.25.25 0 00.25-.25v-9a.25.25 0 00-.25-.25zM6.499 5.701l.048.005a.746.746 0 01.326.125l-.088-.052a.754.754 0 01.336.336l-.036-.064c.01.015.019.03.027.046l.009.018 3 6 .04.094a.75.75 0 01-1.382.576L8.137 11.5H4.763l-.642 1.285a.75.75 0 01-1.381-.576l.04-.094 3-6 .008-.018a.751.751 0 01.027-.046l-.036.064a.754.754 0 01.336-.336l-.088.052A.752.752 0 016.4 5.7h.098zM12.95.2a2.75 2.75 0 012.745 2.582l.005.168v9a.75.75 0 01-1.493.102l-.007-.102v-9a1.25 1.25 0 00-1.122-1.244L12.95 1.7h-9A.75.75 0 013.848.207L3.95.2h9zm-6.5 7.926L5.513 10h1.874L6.45 8.126z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgViewLanguage.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgViewLanguage.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgViewLanguage svgRef={ref} {...props} />);
export default ForwardRef;
